import { createContext, ReactNode, useContext, useMemo } from 'react';
import { useEnrichedAuth } from '../hooks/useEnrichedAuth';
import { AccessRule, hasAccess } from '../components/security/AccessControl';

interface PermissionsContextValue {
  can: (rule?: AccessRule) => boolean;
}

const PermissionsContext = createContext<PermissionsContextValue | undefined>(undefined);

export function PermissionsProvider({ children }: { children: ReactNode }) {
  const { user } = useEnrichedAuth();
  const can = (rule?: AccessRule) => hasAccess(user?.roles ?? undefined, user?.permissions, user?.domains ?? undefined, rule);

  const value = useMemo(() => ({ can }), [user?.roles, user?.permissions]);

  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
}

export function usePermissions() {
  const ctx = useContext(PermissionsContext);
  if (!ctx) throw new Error('usePermissions must be used within PermissionsProvider');
  return ctx;
}
